(function($) {
  new Swiper('.block-imagecarousel .swiper-container', {
    grabCursor: true,
    spaceBetween: 15,
    slidesPerView: 'auto',
    autoHeight: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      576: {
        spaceBetween: 30,
      },
      1024: {
        spaceBetween: 30,
      },
      1400: {
        spaceBetween: 40,
      },
      1500: {
        spaceBetween: 40,
      },
    }
  });
})(jQuery);